<template>
  <el-dropdown @command="handleCommand" trigger="click">
    <span class="el-dropdown-link">
      {{ currentLang === 'zh' ? '中文' : 'English' }}<i class="el-icon-arrow-down el-icon--right"></i>
    </span>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item command="zh">{{ $t('language.zh') }}</el-dropdown-item>
      <el-dropdown-item command="en">{{ $t('language.en') }}</el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
export default {
  name: 'LanguageSwitch',
  computed: {
    currentLang() {
      return this.$i18n.locale
    }
  },
  created() {
    // 组件创建时检查并设置默认语言
    const savedLang = localStorage.getItem('lang');
    if (!savedLang) {
      // 如果没有保存的语言设置，默认使用中文
      this.$i18n.locale = 'zh';
      localStorage.setItem('lang', 'zh');
    }
  },
  methods: {
    handleCommand(command) {
      this.$i18n.locale = command
      localStorage.setItem('lang', command)
    }
  }
}
</script>

<style scoped>
.el-dropdown-link {
  cursor: pointer;
    color: #ffffff;
}

.el-dropdown-link:hover {
  color: rgba(255, 255, 255, 0.8);
}
</style>